// Import functions from other javascript files ( modules ).
import { set_theme_cookie_setting, get_theme_cookie_setting } from '../../../../global/js/cookie.js';


// Test for the next 10 days.
//test_flash_sales_for_multiple_days( 10 );


// When the page is loaded.
document.addEventListener( 'DOMContentLoaded', () => {
	// If there's flash sales settings data
	if ( typeof flash_sales_data !== "undefined" ) {
		const flash_sales_modal = document.querySelector( '.component.modal.flash-sales' );
		const close_button = flash_sales_modal.querySelector( '.button.close' );

		// Should modal be visible? If so; update countdown
		if ( show_flash_sales_modal_check() ) {
			flash_sales_modal.style.display = 'flex';
			update_flash_sales_count_down();
			setInterval( update_flash_sales_count_down, 1000 );
		}

		// Close button
		close_button.onclick = () => {
			flash_sales_modal.style.display = 'none';
			set_theme_cookie_setting( 'flash-sales', { close_time_stamp: new Date().toISOString() } );
		};
	}
} );


/**
 * Update flash sales count down in modal window.
 */
function update_flash_sales_count_down() {
	// Get data
	const current_time = get_current_time_europe_amsterdam();
	const start_day = parseInt( flash_sales_data.start_day );
	const start_time = flash_sales_data.start_time.split( ':' );
	const current_day = current_time.getDay();

	let new_flash_sale_period_start = new Date( current_time );
	let days_to_start = ( start_day - current_day + 7 ) % 7;

	// If today is the start_day but the start_time has passed, set it to next week
	if (
		days_to_start === 0 &&
		(
			current_time.getHours() > parseInt( start_time[0] ) ||
			(
				current_time.getHours() === parseInt( start_time[0] ) &&
				current_time.getMinutes() >= parseInt( start_time[1] )
			)
		)
	) {
		days_to_start = 7;
	}

	new_flash_sale_period_start.setDate( new_flash_sale_period_start.getDate() + days_to_start );
	new_flash_sale_period_start.setHours( parseInt( start_time[0] ), parseInt( start_time[1] ), parseInt( start_time[2] || '0' ), 0 );

	const time_remaining = new_flash_sale_period_start - current_time;

	// Calculate days, hours, and minutes for display purposes
	const days = Math.floor( time_remaining / ( 1000 * 60 * 60 * 24 ) );
	const hours = Math.floor( ( time_remaining % ( 1000 * 60 * 60 * 24 ) ) / ( 1000 * 60 * 60 ) );
	const minutes = Math.floor( ( time_remaining % ( 1000 * 60 * 60 ) ) / ( 1000 * 60 ) );

	const flash_sales_modal_countdown = document.querySelector( '.component.modal.flash-sales .countdown' );

	flash_sales_modal_countdown.querySelector( '.days .value' ).textContent = String( days ).padStart( 2, '0' );
	flash_sales_modal_countdown.querySelector( '.hours .value' ).textContent = String( hours ).padStart( 2, '0' );
	flash_sales_modal_countdown.querySelector( '.minutes .value' ).textContent = String( minutes ).padStart( 2, '0' );
}


/**
 * Determine if the flash sales modal should be shown.
 *
 * @returns {boolean}
 */
function show_flash_sales_modal_check( simulation_date = null ) {
	const saved_time_stamp = get_theme_cookie_setting( 'flash-sales' )?.close_time_stamp;

	// If there is no previous set close timestamp, show modal.
	if ( ! saved_time_stamp ) {
		// Only when testing (test_flash_sales_for_multiple_days).
		if( simulation_date ) {
			console.log( "No saved closing time stamp set. Showing modal." );
		}
		return true;
	}

	// Get current time corrected for time_zone and daylight savings time.
	const current_time = simulation_date ? simulation_date : get_current_time_europe_amsterdam();
	const close_time = new Date( saved_time_stamp );

	// Calculate the next flash sale period start time based on close time.
	const start_day = parseInt( flash_sales_data.start_day );
	const start_time = flash_sales_data.start_time.split( ':' );
	const close_day = close_time.getDay();

	let next_flash_sale_period_start_time = new Date( close_time );
	let days_to_start = ( start_day - close_day + 7 ) % 7;

	// If close day is the start day but the time has passed, set it to next week.
	if ( days_to_start === 0 &&
		(
		close_time.getHours() > parseInt( start_time[0] ) ||
		(
			close_time.getHours() === parseInt( start_time[0] ) &&
			close_time.getMinutes() >= parseInt( start_time[1] )
		)
		)
	) {
		days_to_start = 7;
	}

	next_flash_sale_period_start_time.setDate( next_flash_sale_period_start_time.getDate() + days_to_start );
	next_flash_sale_period_start_time.setHours( parseInt( start_time[0] ), parseInt( start_time[1] ), parseInt( start_time[2] || '0' ), 0 );

	// Check if the modal should be shown
	const show_modal = current_time >= next_flash_sale_period_start_time;

	// Only when testing (test_flash_sales_for_multiple_days).
	if( simulation_date ) {
		console.log( "Next Flash Sale: " + next_flash_sale_period_start_time );
		console.log( "Current Time:    " + current_time );
		console.log( "Closed Time:     " + close_time );
		console.log( "Show Modal:      " + show_modal );
	}

	return show_modal;
}


/**
 * Get the current time adjusted to Amsterdam's time_zone, accounting for daylight savings time.
 */
function get_current_time_europe_amsterdam( simulation_date = null ) {
	// Get current time/date if no simulation time/date
	const current_time = simulation_date ? new Date( simulation_date ) : new Date();
	const time_zone = 'Europe/Amsterdam';

	const options = {
		time_zone,
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
		hour12: false,
	};

	const date_time_format = new Intl.DateTimeFormat( [], options );
	const parts = date_time_format.formatToParts( current_time );

	const getPart = ( type ) => parts.find( part => part.type === type ).value;

	return new Date( `${getPart( 'year' )}-${getPart( 'month' ).padStart( 2, '0' )}-${getPart( 'day' ).padStart( 2, '0' )}T${getPart( 'hour' ).padStart( 2, '0' )}:${getPart( 'minute' ).padStart( 2, '0' )}:${getPart( 'second' ).padStart( 2, '0' )}` );
}


/**
 * Debug function to test for multiple future days at a time
 */
function test_flash_sales_for_multiple_days(  ammount_of_days = 10 ) {
	for (  let current_day = 0; current_day < ammount_of_days; current_day++  ) {
		const simulation_date = new Date();
		simulation_date.setDate(  simulation_date.getDate() + current_day  );

		console.log( `------------- Testing for simulated date: ${simulation_date} -------------` );
		const corrected_simulation_date = get_current_time_europe_amsterdam(  simulation_date  );
		show_flash_sales_modal_check(  corrected_simulation_date  );
	}
}